export default __webpack_public_path__ + "static/software-1-2074923a6b9c97441e0207ccc93d3088.mp4";